{
  "schemaVersion": "cogo.application-composition-full-closure.v1",
  "status": "pass",
  "methodologyStatus": "pass",
  "sourceSamples": [
    {
      "sourceId": "gridone-housing-analysis-source",
      "fixtureId": "gridone-housing-analysis-app",
      "sourceKind": "excel-derived-report",
      "domainLabel": "housing price analysis",
      "layoutPatternRefs": [
        "sidebar-workspace",
        "document-page",
        "dashboard-grid"
      ],
      "blockPatternRefs": [
        "command-header",
        "sidebar-navigation",
        "filter-toolbar",
        "chart-table-composition",
        "document-export-panel"
      ],
      "pagePatternRefs": [
        "admin-workspace-page",
        "analysis-page"
      ],
      "componentTypes": [
        "container",
        "text",
        "image",
        "button",
        "input",
        "select",
        "checkbox",
        "switch",
        "tabs",
        "list",
        "card",
        "chart",
        "data_table",
        "form",
        "nav",
        "dialog",
        "table"
      ],
      "designSystemParts": [
        "color",
        "typography",
        "spacing",
        "radius",
        "shadow",
        "density",
        "surface",
        "componentStyleRule",
        "stateStyleRule",
        "responsiveStyleRule"
      ],
      "componentVocabularyExtended": false,
      "designSystemStructureExtended": false,
      "proofStages": [
        "schema-validation",
        "composition-contract-validation",
        "layout-slot-validation",
        "block-page-reference-validation",
        "design-system-separation-validation",
        "headless-render-proof"
      ]
    },
    {
      "sourceId": "sheet-operations-scorecard-source",
      "fixtureId": "sheet-operations-scorecard-app",
      "sourceKind": "spreadsheet-derived-ops",
      "domainLabel": "spreadsheet operations scorecard",
      "layoutPatternRefs": [
        "sidebar-workspace",
        "dashboard-grid",
        "grid"
      ],
      "blockPatternRefs": [
        "command-header",
        "sidebar-navigation",
        "filter-toolbar",
        "chart-table-composition",
        "data-grid-with-actions"
      ],
      "pagePatternRefs": [
        "admin-workspace-page",
        "analysis-page"
      ],
      "componentTypes": [
        "container",
        "text",
        "image",
        "button",
        "input",
        "select",
        "checkbox",
        "switch",
        "tabs",
        "list",
        "card",
        "chart",
        "data_table",
        "form",
        "nav",
        "dialog",
        "table"
      ],
      "designSystemParts": [
        "color",
        "typography",
        "spacing",
        "radius",
        "shadow",
        "density",
        "surface",
        "componentStyleRule",
        "stateStyleRule",
        "responsiveStyleRule"
      ],
      "componentVocabularyExtended": false,
      "designSystemStructureExtended": false,
      "proofStages": [
        "schema-validation",
        "composition-contract-validation",
        "layout-slot-validation",
        "block-page-reference-validation",
        "design-system-separation-validation",
        "headless-render-proof"
      ]
    },
    {
      "sourceId": "public-data-publication-source",
      "fixtureId": "public-data-publication-app",
      "sourceKind": "publishing-site",
      "domainLabel": "public data publication",
      "layoutPatternRefs": [
        "multi-column",
        "document-page",
        "dashboard-grid"
      ],
      "blockPatternRefs": [
        "command-header",
        "content-list",
        "chart-table-composition",
        "document-export-panel"
      ],
      "pagePatternRefs": [
        "content-index-page",
        "analysis-page"
      ],
      "componentTypes": [
        "container",
        "text",
        "image",
        "button",
        "input",
        "select",
        "checkbox",
        "switch",
        "tabs",
        "list",
        "card",
        "chart",
        "data_table",
        "form",
        "nav",
        "dialog",
        "table"
      ],
      "designSystemParts": [
        "color",
        "typography",
        "spacing",
        "radius",
        "shadow",
        "density",
        "surface",
        "componentStyleRule",
        "stateStyleRule",
        "responsiveStyleRule"
      ],
      "componentVocabularyExtended": false,
      "designSystemStructureExtended": false,
      "proofStages": [
        "schema-validation",
        "composition-contract-validation",
        "layout-slot-validation",
        "block-page-reference-validation",
        "design-system-separation-validation",
        "headless-render-proof"
      ]
    },
    {
      "sourceId": "transaction-admin-source",
      "fixtureId": "transaction-admin-app",
      "sourceKind": "commerce-admin",
      "domainLabel": "transaction admin",
      "layoutPatternRefs": [
        "sidebar-workspace",
        "grid",
        "split"
      ],
      "blockPatternRefs": [
        "command-header",
        "sidebar-navigation",
        "filter-toolbar",
        "data-grid-with-actions",
        "detail-summary"
      ],
      "pagePatternRefs": [
        "admin-workspace-page",
        "transaction-flow-page"
      ],
      "componentTypes": [
        "container",
        "text",
        "image",
        "button",
        "input",
        "select",
        "checkbox",
        "switch",
        "tabs",
        "list",
        "card",
        "chart",
        "data_table",
        "form",
        "nav",
        "dialog",
        "table"
      ],
      "designSystemParts": [
        "color",
        "typography",
        "spacing",
        "radius",
        "shadow",
        "density",
        "surface",
        "componentStyleRule",
        "stateStyleRule",
        "responsiveStyleRule"
      ],
      "componentVocabularyExtended": false,
      "designSystemStructureExtended": false,
      "proofStages": [
        "schema-validation",
        "composition-contract-validation",
        "layout-slot-validation",
        "block-page-reference-validation",
        "design-system-separation-validation",
        "headless-render-proof"
      ]
    },
    {
      "sourceId": "knowledge-feed-review-source",
      "fixtureId": "knowledge-feed-review-app",
      "sourceKind": "knowledge-feed",
      "domainLabel": "knowledge feed review",
      "layoutPatternRefs": [
        "feed",
        "multi-column",
        "stack"
      ],
      "blockPatternRefs": [
        "command-header",
        "content-list",
        "detail-summary"
      ],
      "pagePatternRefs": [
        "content-index-page",
        "detail-page"
      ],
      "componentTypes": [
        "container",
        "text",
        "image",
        "button",
        "input",
        "select",
        "checkbox",
        "switch",
        "tabs",
        "list",
        "card",
        "chart",
        "data_table",
        "form",
        "nav",
        "dialog",
        "table"
      ],
      "designSystemParts": [
        "color",
        "typography",
        "spacing",
        "radius",
        "shadow",
        "density",
        "surface",
        "componentStyleRule",
        "stateStyleRule",
        "responsiveStyleRule"
      ],
      "componentVocabularyExtended": false,
      "designSystemStructureExtended": false,
      "proofStages": [
        "schema-validation",
        "composition-contract-validation",
        "layout-slot-validation",
        "block-page-reference-validation",
        "design-system-separation-validation",
        "headless-render-proof"
      ]
    }
  ],
  "mining": {
    "schemaVersion": "cogo.application-composition-mining-result.v1",
    "sourceCount": 5,
    "candidateCount": 21,
    "candidates": [
      {
        "kind": "layout-pattern",
        "patternId": "dashboard-grid",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source",
          "sheet-operations-scorecard-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app",
          "sheet-operations-scorecard-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "layout-pattern",
        "patternId": "document-page",
        "supportCount": 2,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "layout-pattern",
        "patternId": "feed",
        "supportCount": 1,
        "sourceIds": [
          "knowledge-feed-review-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "layout-pattern",
        "patternId": "grid",
        "supportCount": 2,
        "sourceIds": [
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "layout-pattern",
        "patternId": "multi-column",
        "supportCount": 2,
        "sourceIds": [
          "knowledge-feed-review-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "layout-pattern",
        "patternId": "sidebar-workspace",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "layout-pattern",
        "patternId": "split",
        "supportCount": 1,
        "sourceIds": [
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "layout-pattern",
        "patternId": "stack",
        "supportCount": 1,
        "sourceIds": [
          "knowledge-feed-review-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "page-pattern",
        "patternId": "admin-workspace-page",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "page-pattern",
        "patternId": "analysis-page",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source",
          "sheet-operations-scorecard-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app",
          "sheet-operations-scorecard-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "page-pattern",
        "patternId": "content-index-page",
        "supportCount": 2,
        "sourceIds": [
          "knowledge-feed-review-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "page-pattern",
        "patternId": "detail-page",
        "supportCount": 1,
        "sourceIds": [
          "knowledge-feed-review-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "page-pattern",
        "patternId": "transaction-flow-page",
        "supportCount": 1,
        "sourceIds": [
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "chart-table-composition",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source",
          "sheet-operations-scorecard-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app",
          "sheet-operations-scorecard-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "command-header",
        "supportCount": 5,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "knowledge-feed-review-source",
          "public-data-publication-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "knowledge-feed-review-app",
          "public-data-publication-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "content-list",
        "supportCount": 2,
        "sourceIds": [
          "knowledge-feed-review-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "data-grid-with-actions",
        "supportCount": 2,
        "sourceIds": [
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "detail-summary",
        "supportCount": 2,
        "sourceIds": [
          "knowledge-feed-review-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "document-export-panel",
        "supportCount": 2,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "filter-toolbar",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "sidebar-navigation",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": []
      }
    ]
  },
  "promotionGate": {
    "schemaVersion": "cogo.application-composition-promotion-gate.v1",
    "minSupport": 3,
    "status": "pass",
    "promotedPatternCount": 8,
    "candidatePatternCount": 13,
    "rejectedPatternCount": 0,
    "promotedPatternIds": [
      "layout-pattern:dashboard-grid",
      "layout-pattern:sidebar-workspace",
      "page-pattern:admin-workspace-page",
      "page-pattern:analysis-page",
      "ui-block:chart-table-composition",
      "ui-block:command-header",
      "ui-block:filter-toolbar",
      "ui-block:sidebar-navigation"
    ],
    "rejectedPatternIds": [],
    "candidates": [
      {
        "kind": "layout-pattern",
        "patternId": "dashboard-grid",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source",
          "sheet-operations-scorecard-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app",
          "sheet-operations-scorecard-app"
        ],
        "status": "promoted",
        "failures": []
      },
      {
        "kind": "layout-pattern",
        "patternId": "document-page",
        "supportCount": 2,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": [
          "support 2 is below promotion threshold 3"
        ]
      },
      {
        "kind": "layout-pattern",
        "patternId": "feed",
        "supportCount": 1,
        "sourceIds": [
          "knowledge-feed-review-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app"
        ],
        "status": "candidate",
        "failures": [
          "support 1 is below promotion threshold 3"
        ]
      },
      {
        "kind": "layout-pattern",
        "patternId": "grid",
        "supportCount": 2,
        "sourceIds": [
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": [
          "support 2 is below promotion threshold 3"
        ]
      },
      {
        "kind": "layout-pattern",
        "patternId": "multi-column",
        "supportCount": 2,
        "sourceIds": [
          "knowledge-feed-review-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": [
          "support 2 is below promotion threshold 3"
        ]
      },
      {
        "kind": "layout-pattern",
        "patternId": "sidebar-workspace",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "promoted",
        "failures": []
      },
      {
        "kind": "layout-pattern",
        "patternId": "split",
        "supportCount": 1,
        "sourceIds": [
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": [
          "support 1 is below promotion threshold 3"
        ]
      },
      {
        "kind": "layout-pattern",
        "patternId": "stack",
        "supportCount": 1,
        "sourceIds": [
          "knowledge-feed-review-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app"
        ],
        "status": "candidate",
        "failures": [
          "support 1 is below promotion threshold 3"
        ]
      },
      {
        "kind": "page-pattern",
        "patternId": "admin-workspace-page",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "promoted",
        "failures": []
      },
      {
        "kind": "page-pattern",
        "patternId": "analysis-page",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source",
          "sheet-operations-scorecard-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app",
          "sheet-operations-scorecard-app"
        ],
        "status": "promoted",
        "failures": []
      },
      {
        "kind": "page-pattern",
        "patternId": "content-index-page",
        "supportCount": 2,
        "sourceIds": [
          "knowledge-feed-review-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": [
          "support 2 is below promotion threshold 3"
        ]
      },
      {
        "kind": "page-pattern",
        "patternId": "detail-page",
        "supportCount": 1,
        "sourceIds": [
          "knowledge-feed-review-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app"
        ],
        "status": "candidate",
        "failures": [
          "support 1 is below promotion threshold 3"
        ]
      },
      {
        "kind": "page-pattern",
        "patternId": "transaction-flow-page",
        "supportCount": 1,
        "sourceIds": [
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": [
          "support 1 is below promotion threshold 3"
        ]
      },
      {
        "kind": "ui-block",
        "patternId": "chart-table-composition",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source",
          "sheet-operations-scorecard-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app",
          "sheet-operations-scorecard-app"
        ],
        "status": "promoted",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "command-header",
        "supportCount": 5,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "knowledge-feed-review-source",
          "public-data-publication-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "knowledge-feed-review-app",
          "public-data-publication-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "promoted",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "content-list",
        "supportCount": 2,
        "sourceIds": [
          "knowledge-feed-review-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": [
          "support 2 is below promotion threshold 3"
        ]
      },
      {
        "kind": "ui-block",
        "patternId": "data-grid-with-actions",
        "supportCount": 2,
        "sourceIds": [
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": [
          "support 2 is below promotion threshold 3"
        ]
      },
      {
        "kind": "ui-block",
        "patternId": "detail-summary",
        "supportCount": 2,
        "sourceIds": [
          "knowledge-feed-review-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "knowledge-feed-review-app",
          "transaction-admin-app"
        ],
        "status": "candidate",
        "failures": [
          "support 2 is below promotion threshold 3"
        ]
      },
      {
        "kind": "ui-block",
        "patternId": "document-export-panel",
        "supportCount": 2,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "public-data-publication-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "public-data-publication-app"
        ],
        "status": "candidate",
        "failures": [
          "support 2 is below promotion threshold 3"
        ]
      },
      {
        "kind": "ui-block",
        "patternId": "filter-toolbar",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "promoted",
        "failures": []
      },
      {
        "kind": "ui-block",
        "patternId": "sidebar-navigation",
        "supportCount": 3,
        "sourceIds": [
          "gridone-housing-analysis-source",
          "sheet-operations-scorecard-source",
          "transaction-admin-source"
        ],
        "fixtureIds": [
          "gridone-housing-analysis-app",
          "sheet-operations-scorecard-app",
          "transaction-admin-app"
        ],
        "status": "promoted",
        "failures": []
      }
    ]
  },
  "reportFixtureBoundary": {
    "schemaVersion": "cogo.report-fixture-boundary-result.v1",
    "status": "pass",
    "classification": "application-instance-fixture",
    "fixtureId": "gridone-housing-analysis-app",
    "promotedUiOntology": false,
    "promotedDesignOntology": false,
    "publicKgShardBlocked": true,
    "failures": []
  },
  "productHarnessSeparation": {
    "schemaVersion": "cogo.product-harness-separation-result.v1",
    "status": "pass",
    "productArtifactId": "gridone-housing-report-product-app",
    "harnessArtifactId": "gridone-housing-validation-harness",
    "productShellStatus": "pass",
    "productStyleStatus": "pass",
    "failures": []
  },
  "browserE2eProofContract": {
    "schemaVersion": "cogo.application-composition-browser-e2e-proof-contract.v1",
    "proofCommand": "pnpm agentic:cogo-housing-browser-e2e",
    "productBrowserProofCommand": "pnpm agentic:cogo-housing-product-report-browser-proof",
    "sourceFirstProofCommand": "pnpm agentic:cogo-housing-ci-source-first-proof",
    "requiredGateIds": [
      "B0 source-first-cogo-binding-plan-consumed",
      "B1 local-csv-source-integrity",
      "B2 headless-cogo-runtime-smoke",
      "B3 chart-source-row-parity",
      "B4 workbook-chart-extraction-parity",
      "B4b excel-workbook-chartpart-surface-parity",
      "B5 all-chart-panels-rendered",
      "B6 all-source-table-dom-value-parity",
      "B7 all-report-section-surfaces-rendered",
      "B8 document-export-parity",
      "B9 no-gridone-domain-policy"
    ],
    "requiredChartSurfaceCount": 23,
    "requiredTableSurfaceCount": 22,
    "requiredReportSectionCount": 40,
    "mixedBarLineComboChartRequired": true,
    "screenshotEvidenceRequired": true,
    "browserRenderRequired": true
  },
  "handoffContract": {
    "schemaVersion": "cogo.application-composition-handoff-contract.v1",
    "methodologyDoc": "docs/agentic/COGO-APPLICATION-COMPOSITION-ONTOLOGY-METHODOLOGY-2026-06-26.md",
    "closureDoc": "docs/agentic/COGO-APPLICATION-COMPOSITION-FULL-CLOSURE-2026-06-26.md",
    "proofArtifact": "docs/agentic/evidence/application-composition-full-closure-proof.json",
    "studioConsumes": [
      "methodologyContract",
      "fixtureClassification",
      "promotionGate",
      "styleSeparation",
      "reportApplicationShell",
      "browserE2eProofContract"
    ],
    "studioMustNotDo": [
      "promote report/Gridone/domain labels into component vocabulary",
      "embed raw visual styles in generated Cogo UI",
      "treat validation harness output as a user-facing product application",
      "publish without evidence packet status"
    ]
  },
  "workstreams": [
    {
      "id": "W1_REPORT_FIXTURE_BOUNDARY",
      "title": "Existing report/Gridone ontology is classified as fixture, not core ontology.",
      "status": "pass",
      "evidence": [
        "packages/cogo-validator/ontology/gridone-backoffice-report-contract-v1.json",
        "scripts/check-publish-shard-fresh.mjs UNPUBLISHED fixture boundary"
      ],
      "failures": []
    },
    {
      "id": "W2_PATTERN_MINING_PIPELINE",
      "title": "Pattern mining emits candidate layout/block/page patterns from multiple app sources.",
      "status": "pass",
      "evidence": [
        "mineApplicationCompositionCandidates()",
        "APPLICATION_COMPOSITION_MINING_SOURCES"
      ],
      "failures": []
    },
    {
      "id": "W3_PROMOTION_GATE",
      "title": "Promotion gate requires repeated, source-backed, non-domain-specific patterns.",
      "status": "pass",
      "evidence": [
        "evaluateApplicationCompositionPromotion()"
      ],
      "failures": []
    },
    {
      "id": "W4_DESIGN_SYSTEM_INJECTION",
      "title": "Design-system injection is enforced; Cogo UI carries structure and @ds authority only.",
      "status": "pass",
      "evidence": [
        "assessBlockStyleSeparation(strict)",
        "STYLE_SEPARATION_GENERATOR_CONTRACT"
      ],
      "failures": []
    },
    {
      "id": "W5_GRIDONE_PRODUCT_APP_BLUEPRINT",
      "title": "Gridone report application blueprint is user-facing and follows composition methodology.",
      "status": "pass",
      "evidence": [
        "buildGridoneReportProductApplicationFixture()",
        "assessReportApplicationShell()"
      ],
      "failures": []
    },
    {
      "id": "W6_HARNESS_PRODUCT_SEPARATION",
      "title": "Validation harness remains a separate artifact from the user-facing product app.",
      "status": "pass",
      "evidence": [
        "validateProductHarnessSeparation()"
      ],
      "failures": []
    },
    {
      "id": "W7_BROWSER_E2E_PROOF_CONTRACT",
      "title": "Browser E2E proof contract covers chart/table/section parity and mixed combo charts.",
      "status": "pass",
      "evidence": [
        "pnpm agentic:cogo-housing-browser-e2e",
        "pnpm agentic:cogo-housing-product-report-browser-proof"
      ],
      "failures": []
    },
    {
      "id": "W8_HANDOFF_AND_EVIDENCE",
      "title": "Downstream Studio/platform sessions receive explicit contract and evidence paths.",
      "status": "pass",
      "evidence": [
        "docs/agentic/COGO-APPLICATION-COMPOSITION-ONTOLOGY-METHODOLOGY-2026-06-26.md",
        "docs/agentic/COGO-APPLICATION-COMPOSITION-FULL-CLOSURE-2026-06-26.md",
        "docs/agentic/evidence/application-composition-full-closure-proof.json"
      ],
      "failures": []
    }
  ]
}
